import { useState } from 'react'

/**
 * Tiny shared state container for the admin CRUD pages: tracks the row being
 * edited (if any) plus the open form draft. Keeps the page-level component
 * scannable by pushing the open/edit/clear plumbing out of the body.
 */
export function useCrudState<TRow, TForm>() {
	const [editing, setEditing] = useState<TRow | null>(null)
	const [form, setForm] = useState<TForm | null>(null)

	const openCreate = (blank: TForm) => {
		setEditing(null)
		setForm(blank)
	}
	const openEdit = (row: TRow, draft: TForm) => {
		setEditing(row)
		setForm(draft)
	}
	const close = () => {
		setForm(null)
		setEditing(null)
	}

	return { editing, form, setForm, openCreate, openEdit, close, isOpen: form !== null, isEditing: editing !== null }
}
